import { observer } from 'mobx-react'
import TabController from '../../../infra/TabController'
import { OpportunitiesTabs } from '../../OpportunitiesRootViewModel'
import { TabItem, TabBar } from '../../../components/TabBar'
import * as React from 'react'

interface OpportunitiesTabBarProps {
  tabsController: TabController<OpportunitiesTabs>
}

export default observer(function OpportunitiesTabBar({
  tabsController,
}: OpportunitiesTabBarProps) {
  return (
    <TabBar align="left">
      <TabItem
        active={tabsController.current.tab === OpportunitiesTabs.Jobs}
        onClick={() => tabsController.change(OpportunitiesTabs.Jobs)}
      >
        Available jobs
      </TabItem>
      <TabItem
        active={tabsController.current.tab === OpportunitiesTabs.Workspaces}
        onClick={() => tabsController.change(OpportunitiesTabs.Workspaces)}
      >
        Outsourcing posts
      </TabItem>
    </TabBar>
  )
})
